import { mapActions, mapState } from 'vuex';
import pendingRequest from '@/components/wallet/pending-requests/pending-request-withdrawal/pending-request-withdrawal.vue';
import contentLoaderMixin from '@/mixins/contentLoader';
import alertBox from '@/components/generics/alert-box/alert-box.vue';

export default {
  mixins: [
    contentLoaderMixin,
  ],
  components: {
    alertBox,
    pendingRequest,
  },
  created() {
    this.getPendingWithdrawals().then(() => {
      this.isComponentReady = true;
    });
  },
  computed: {
    ...mapState('wallet', ['pendingRequests']),
  },
  methods: {
    ...mapActions('wallet', ['getPendingWithdrawals']),
    onComplete() {
      this.getPendingWithdrawals();
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/wallet/pending-requests/pending-requests-list-withdrawal/pending-requests-list-withdrawal.js